import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// @mui
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';

import { Stack, AppBar, Toolbar, IconButton, Typography, Tooltip, Box, useMediaQuery } from '@mui/material';
// utils
import { bgBlur } from '../../utils/cssStyles';

// hooks
import useResponsive from '../../hooks/useResponsive';

// config
import { HEADER } from '../../config-global';
// components
import Iconify from '../../components/iconify';
import { useAuthContext } from '../../auth/useAuthContext';
import LoginDeailsService from '../../services/logindetails.service';
import AppCache from '../../services/appcache';
import usernameService from '../../services/username.service';

// import { companyName, companyLogoPath } from '../../../utils/companyname'

// ----------------------------------------------------------------------

Header.propTypes = {
    onOpenNav: PropTypes.func,
    openNav: PropTypes.func,
    navWidth: PropTypes.number,
};

export default function Header({ onOpenNav, openNav, navWidth }) {
    const theme = useTheme(); const navigate = useNavigate();
    const { logout } = useAuthContext();
    const isDesktop = useResponsive('up', 'lg');
    const [userData, setUserData] = useState([]);
    const IsRedirect = AppCache.GetIsRedirect();
    const [userName, setUserName] = useState('');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    useEffect(() => {
        LoginDeailsService.CallLoginAPI()
            .then((response) => {
                if (response.status === 200) {
                    setUserData(response.data);
                }
                else {
                     //  console.log("error");
                }
            })
            .catch(error => {
                 //  console.log("in catch", error);
            });
    }, []);



    useEffect(() => {
        const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
        if (CurrentLoggedInUser?.Token) {
            usernameService
                .then((userNameServiceInstance) => userNameServiceInstance.GetUserName())
                .then((response) => {
                    if (response.status === 200 && response?.data?.length > 0) {
                        const fetchedUserName = response?.data[0]?.UserName || 'Guest';
                        setUserName(fetchedUserName);
                        
                    } else {
                         //  console.log("Failed to fetch username:", response?.data);
                    }
                })
                .catch((err) => {
                     //  console.log("Error fetching username:", err);
                    setUserName('Guest');
                });
        } else {
             //  console.log("Token not available");           
        }
    }, []);

    const handleLogout = async () => {
        try {
            logout();
            sessionStorage.clear();
            localStorage.clear();
            navigate(-1);
        } catch (error) {
            console.error(error);
        }
    };

    const renderContent = (
        <Stack
            flexGrow={1}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src="/logo/ProClaimz Logo.jpg"
                    alt="ProClaimz Logo"
                    style={{
                        height: isMobile ? 15 : 25,
                        width: 'auto',
                        objectFit: 'contain',
                        marginRight: theme.spacing(0.5),
                    }}
                />
            </Box>
           
            <Box sx={{ display: 'flex', alignItems: 'center' }}>               
                <Typography
                    variant="body2"
                    sx={{
                        color: 'gray',
                        fontSize: { sx: '1rem', sm: '1rem', md: '1.3rem', lg: '1.3rem' },
                        lineHeight: '0.9rem',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={userData.companyLogo}
                        alt="Company Logo"
                        style={{ height: 40, objectFit: 'contain', marginRight: theme.spacing(0.5) }}
                    />
                    {userData.companyName}
                </Typography>
            </Box>

            <Stack direction="row" spacing={2} alignItems="center">
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: { sx: '0.7rem', sm: '0.7rem', md: '0.9rem', lg: '0.9rem' },
                        color: theme.palette.text.primary,
                    }}
                >
                    {userName}
                </Typography>

                <Tooltip title="Logout">
                    <IconButton
                        sx={{
                            width: 40,
                            height: 40,
                            color: IsRedirect === '1' ? '#FFF' : '#B50000',
                            ":hover": {
                                cursor: IsRedirect === '1' ? "default" : "pointer",
                                color: IsRedirect === '1' ? '#FFF' : "#FB0000",
                            },
                        }}
                        onClick={(event) => {
                            if (IsRedirect !== '1') {
                                handleLogout(event); // NOSONAR
                            }
                        }}
                    >
                        <Iconify icon="mdi:shutdown" />
                    </IconButton>
                </Tooltip>
            </Stack>
        </Stack>
    );


    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100%)`,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                    backgroundColor: theme.palette.background.paper,
                  
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 2 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}
